// extracted by mini-css-extract-plugin
export default {"footerLinksContainer":"Footer_footerLinksContainer__qhCoh","footerLink":"Footer_footerLink__Sz3jQ"};